import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndicatorsService {

  indicator: number = 4;

  constructor() { }

  setIndicator(n: number) {
    this.indicator = n;
  }

  getIndicator() {
    return this.indicator;
  }

}
